import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import { AuthProvider } from './contexts/AuthContext';
import syncService from './services/databaseSync';
import PrivateRoute from './components/PrivateRoute';
import ServiceProviderHeader from './components/ServiceProviderHeader';
import Footer from './components/Footer';
import DashboardPage from './pages/DashboardPage';
import JobRequestsPage from './pages/JobRequestsPage';
import EarningsPage from './pages/EarningsPage';
import ProfilePage from './pages/ProfilePage';
import ApplyPage from './pages/ApplyPage';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import './styles/variables.css';
import './styles/global.css';

const ENABLE_BIDIRECTIONAL_SYNC = process.env.REACT_APP_ENABLE_BIDIRECTIONAL_SYNC === 'true';

function SyncInitializer() {
    const { currentUser } = useAuth();

    useEffect(() => {
        if (!currentUser || !ENABLE_BIDIRECTIONAL_SYNC) return;

        // Sync is opt-in only. Running this in every client session can cause stale write conflicts.
        syncService.initializeBidirectionalSync();

        return () => {
            syncService.stopAllListeners();
        };
    }, [currentUser]);

    return null;
}

// Redirect logged-in users from landing page to dashboard
const HomeRedirect = () => {
    const { currentUser } = useAuth();
    return currentUser ? <Navigate to="/dashboard" replace /> : <LandingPage />;
};

function App() {
    return (
        <AuthProvider>
            <Router>
                <SyncInitializer />
                <div className="App">
                    <ServiceProviderHeader />
                    <Routes>
                        <Route path="/" element={<HomeRedirect />} />
                        <Route path="/dashboard" element={
                            <PrivateRoute>
                                <DashboardPage />
                            </PrivateRoute>
                        } />
                        <Route path="/job-requests" element={
                            <PrivateRoute>
                                <JobRequestsPage />
                            </PrivateRoute>
                        } />
                        <Route path="/earnings" element={
                            <PrivateRoute>
                                <EarningsPage />
                            </PrivateRoute>
                        } />
                        <Route path="/profile" element={
                            <PrivateRoute>
                                <ProfilePage />
                            </PrivateRoute>
                        } />
                        <Route path="/apply" element={<ApplyPage />} />
                        <Route path="/signup" element={<SignupPage />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                    </Routes>
                    <Footer />
                </div>
            </Router>
        </AuthProvider>
    );
}

export default App;
